import { render, staticRenderFns } from "./infoCardDoble.vue?vue&type=template&id=6a574b17&scoped=true"
import script from "./infoCardDoble.vue?vue&type=script&lang=js"
export * from "./infoCardDoble.vue?vue&type=script&lang=js"
import style0 from "./infoCardDoble.vue?vue&type=style&index=0&id=6a574b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a574b17",
  null
  
)

export default component.exports